
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../../commons/form/InputText'
import InputSelect from '../../../commons/form/InputSelect'
import { handleKeyDown } from '../../../../util/utils'

class ProcessingAgencyIntegrationDocTypeUsesMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.processingAgencyDocTypeUse)
    }
  }

  submitProcessingAgencyDocTypeUse (values) {
    const processingAgencyDocTypeUse = {
      ProcessingAgencyDocTypeUseId: this.props.processingAgencyDocTypeUse?.processingAgencyDocTypeUseId,
      ProcessingAgencyId: this.props.agency.processingAgencyId,
      DocumentTypeUseId: values.documentTypeUseId,
      PaperworkTypeId: values.paperworkTypeId,
      DocumentCode: values.documentCode,
      IsReturnDocument: this.props.isReturnDocument
    }

    this.props.actions.submitProcessingAgencyDocTypeUses(this.props.agency.processingAgencyId, processingAgencyDocTypeUse)
  }

  render () {
    const {
      t, handleSubmit,
      showModal
    } = this.props
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.DOC_TYPE_USES.'
    return (
      <Modal id="processingAgencyIntegrationDocTypeUsesMasterModal" className="_nf" show={showModal} onHide={() => this.props.actions.showProcessingAgencyDocTypeUsesModal(null, false)} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitProcessingAgencyDocTypeUse.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={() => this.props.actions.showProcessingAgencyDocTypeUsesModal(null, false)}>
            <Modal.Title>{t(`${tKey}DOC_TYPE_USE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="documentTypeUseId"
                controlLabel={t(`${tKey}DOC_TYPE_USE`)}
                placeholder={t(`${tKey}DOC_TYPE_USE`)}
                options={this.props.combos.documentTypeUseCombo}
                valueKey="id"
                labelKey="value"
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="paperworkTypeId"
                controlLabel={t(`${tKey}PAPERWORK_TYPE`)}
                placeholder={t(`${tKey}PAPERWORK_TYPE`)}
                options={this.props.combos.paperworkTypes}
                valueKey="id"
                labelKey="value"
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="documentCode"
                controlLabel={t(`${tKey}PROCESSING_AGENCY_CODE`)}
                placeholder={t(`${tKey}PROCESSING_AGENCY_CODE`)}
                required={[true]}
                maxLength={50}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-L">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}MODAL.SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editProcessingAgencyDocTypeUseModal',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.DOC_TYPE_USES.VALIDATION.'
    if (!values.documentTypeUseId) {
      error.documentTypeUseId = props.t(`${tKey}VALUE_REQUIRED`)
    }

    if (!values.documentCode) {
      error.documentCode = props.t(`${tKey}VALUE_REQUIRED`)
    }

    return Object.keys(error).length > 0 ? error : {}
  }
})(ProcessingAgencyIntegrationDocTypeUsesMasterModal)
